<wl-content-section [id]="id()" [theme]="theme()">
  <wl-contact-section
    [uid]="uid()!"
    [title]="title()!"
    [introduction]="introduction()!"
    [contactItems]="contactItems()"
  />
</wl-content-section>
